import React from 'react';
import {
  ItemsContainer,
  ItemsTitle,
  ItemsGrid,
  ItemCard
} from './Items.styled';

const Items = () => {
  return (
    <ItemsContainer>
      <ItemsTitle>Items</ItemsTitle>
      <ItemsGrid>
        <ItemCard>
          {/* Drive items will go here */}
        </ItemCard>
      </ItemsGrid>
    </ItemsContainer>
  );
};

export default Items;
